import { Component, OnInit, OnDestroy, ɵɵresolveBody,NgZone,ChangeDetectorRef } from '@angular/core';
import { WebSocketService }  from "../../service/message.ts.service";
import { menulist } from '../class/status';
import { page }  from '../class/status';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Dep } from '../../comm/class/auth';

declare var $:any;

@Component({
  selector: 'app-gm',
  templateUrl: './gm.component.html',
  styleUrls: ['./gm.component.css'],
  providers: [WebSocketService]
})
export class GmComponent implements OnInit, OnDestroy {

  tcontent:any[] = [
    {title:'用戶',content:'name',type:2},
    {title:'狀態',content:'s_name'},
    {title:'回報點',content:'create_dt'},
    {title:'描述',content:'descript',type:3},
    {title:'操作',content:'gg',type:3},
  ];
  valuetag = [];
  menu_list:menulist = [{id:'5',name:'問題表單'},{id:'4',name:'群發設定'},{id:'2',name:'回復客戶'},{id:'0',name:'在線列表'},{id:'1',name:'對話紀錄'}];
  msg_filter_list:menulist = [{id:'99',name:'全部'},{id:'0',name:'直接發送'},{id:'1',name:'預排發送'},{id:'-1',name:'取消發送'},{id:'-2',name:'已發送'}];
  feedback_filter_list:menulist = [{id:'99',name:'全部'},{id:'0',name:'未處理'},{id:'1',name:'處理中'},{id:'-1',name:'不處理'},{id:'2',name:'已結案'}];
  filter_list:menulist = [{id:'0',name:'全部顯示'},{id:'1',name:'未讀訊息'}];
  filter_type = '1';
  now:string = '5';
  msg_now:string = '99';

  target:{uid:string,profile_pic:string,name:string}={uid:'-1',profile_pic:'',name:''}
  search_target:string = '';
  me:{uid:string,profile_pic:string,name:string}={uid:'TALKMATE8888',profile_pic:environment.pic+'talkmate.png',name:'淘妹官方帳號'}
  // me:{uid:string,profile_pic:string,name:string}={uid:'ALV3V71HJK17',profile_pic:'http://172.105.228.202/voxy/file/mode_2/20210714/60eeb5e14b9a7.jpeg',name:'wen'}
  tag_list_type = [];
  groupTaglist = [];
  groupTagArr = [];
  tool_obj:any={tag:'-2',tag1:'-2'};
  oriNum = 0;
  user_search = [];

  freshload:boolean = false;
  nowpacket:number = 0;
  send_data:{msg:string} = {msg:''}
  logs:any=[];
  data:any=[];
  userlist:any=[];
  loading:boolean=true;
  pageobj:page = {page:0,count:10,total_count:0};
  edit_data:any=[];
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  confirm_modal:{show:boolean,count:number,save_type:number} = {show:false,count:0,save_type:0};
  toast:{show:boolean,msg:string} = {show:false,msg:''};
  pending_toast:string = '';
  constructor( 
    private webSocketService:WebSocketService,    
    public httpClient: HttpClient,  
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef, 
  ) {
    
    const url = environment.socket 
    this.webSocketService.start( url,this.on_message.bind(this) );
    
  }

  calltagList(event){

    this.groupTagArr = event;

  }

  checkData(){
    
    this.user_search = [];

    this.edit_data.user_name.forEach(v =>{
        let tmp ={id:v.id,name:v.name};
        this.user_search.push(tmp);

    });


    let edit_arr = JSON.parse(this.edit_data.tag_id);

    edit_arr.forEach(v => {
        this.valuetag.forEach((value,key) => {
            value.forEach(vx => {
                if(vx.id == v){
                    this.tool_obj.groupTag = [];
                    this.tool_obj.tag = key;
                    this.tool_obj.groupTag=[vx.name];
                    this.showType(this.tool_obj.tag);

                }
            });
                               
        });
    });

    this.tool_obj.tag = '-2';
  }

  clearbtnuser(i){
    this.user_search.splice(i, 1);
  }
  
  clearbtn(item,idx,index){
   
    this.groupTagArr[idx].splice(index, 1);
   
    if(this.tool_obj.groupTag.includes(item)){
        const index = this.tool_obj.groupTag.indexOf(item);
        this.ngZone.run(() => {
            this.tool_obj.groupTag.splice(index, 1);
            this.tool_obj.groupTag = [...this.tool_obj.groupTag];
            this.cdr.detectChanges(); // 或者使用 this.cdr.markForCheck();
        });
    }
    
  }

  
  showdeType(num){

    if(this.groupTagArr[num] != null){
        this.tool_obj.groupTag  = this.groupTagArr[num];
    }
  
  }

  showType(num){

    if(this.groupTagArr.length == 0){ //一開始第一個值

            this.groupTagArr[num] = this.tool_obj.groupTag;
    }

    if(num == this.oriNum){ 

        if(this.tool_obj.groupTag.length <  this.groupTagArr[num].length){

            this.groupTagArr[num] =  this.groupTagArr[num].filter(item => this.tool_obj.groupTag.includes(item));

        }else{

            this.tool_obj.groupTag.forEach(item => {

               
                if (!this.groupTagArr[num].includes(item)) {
                    this.groupTagArr[num].push(item);
                }

            });

        }
        
       
    }else{ //新類型第一個值

        this.groupTagArr[num] = this.tool_obj.groupTag;
    }


    this.oriNum = num;
    // this.init_list();

 }

  on_message(data:any){
    // console.log(data);
    if (data['action']=="invade"){
      this.now = '3';
    }else{
      const name = data.to_username;
      let content = '';
      let media = '';
        if(data.type*1 != 1){
          content = data.content;
          media = data.media?JSON.parse(data.media):'';
        }else{
          // content = data.content.replace(/\n/g,"<br/>");
          content = data.content;
        }


      const tmp = {
        type:data.type,
        time:data.time,
        name:name,
        user_img: data.to_userimg,
        meid:data.to_userid,
        action:data.action,
        content:content,
        media:media,
        list:[],
        unsafe:0,
        me:false
      }
      if(data.type*1 !== 3){
        if(content.indexOf("<script>")!=-1){
          tmp.unsafe = 1;
        }
      }

      const meuid = typeof(this.me)!=='undefined'?this.me.uid:'';

      // console.log(tmp.media,(tmp.content.length>0 || tmp.media.length > 0));
      if( tmp.action == 'say'){
        console.log(tmp);
          if( tmp.meid == meuid){
            tmp.me = true;
          }
          this.logs.push(tmp)
          window.setTimeout(()=>{
            this.get_element();
         },500)
        
      }  
    }

		
  }


  async handleFileInput(files: FileList){
      console.log(files,'up');
        var that = this;
        that.loading = true;
        let body :FormData = new FormData();
        const send_url = environment.serverurl + "/upload.php";
        const xhr = new XMLHttpRequest();
        const say = that.webSocketService.get_orimsg('say')

        say.user_id = this.me.uid;
        say.user_name = this.me.name;
        say.user_img = this.me.profile_pic;
        say.to_userid = this.target.uid;

        body.append("token",Dep.token);
        body.append("file[]",files[0]);
        if(files[0].type.indexOf('video')!=-1){
          const reader = new FileReader();
          const url = window.URL.createObjectURL(files[0]); // 取得檔案
          const video = document.getElementsByTagName('video')[document.getElementsByTagName('video').length-1];
          video.src = url + "#t=0.1";
          video.addEventListener('canplay', function () {
            const $this = this;
            window.setTimeout(async function () {
              const image = await window.createImageBitmap($this);
              const canvas = document.getElementsByTagName('canvas')[0];

              const ratio = video.videoWidth / video.videoHeight;

              canvas.width = 400
              canvas.height = 400 / ratio;
              canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
              const img = canvas.toDataURL("image/jpeg", 0.5);
              body.append("preview_pic", img);
              xhr.open("POST", send_url, true);
              xhr.onloadend = function () {
                var res = JSON.parse(this.response);
                that.loading = false;
                if (res.status) {
                  const media = { file: [{ file_id: res.data[0].file_id, file_length: '', file_url: res.data[0]['file_url'], file_preview: res.data[0].preview_url }] };
                  say.type = 4;
                  say.media = JSON.stringify(media);
                  that.webSocketService.sendMessage(say);
                }
              };
              xhr.send(body);
            }, 500);
          })
        }else{
          xhr.open("POST", send_url, true);
          xhr.onloadend=function(){
              var res = JSON.parse(this.response)
              that.loading = false;
              if(res.status){
                const media = {file:[{file_id:res.data[0].file_id,file_length:'',file_url:res.data[0]['file_url'],file_preview:res.data[0].preview_url}]};
                say.type = 3;
                say.media = JSON.stringify(media);
                that.webSocketService.sendMessage(say);
              }
          }
          xhr.send(body);
        } 
        const InputElement: HTMLInputElement = document.getElementById('file') as HTMLInputElement
        InputElement.value = '';

  }
  get_element(){
    if(document.getElementById('chat_box')){
      const div = document.getElementById('chat_box');
      div.scrollTop = div.scrollHeight;
    }else{
      window.setTimeout(()=>{
          this.get_element();
      },500)
    }

  }

  ngOnInit(): void {
    this.choose();
    console.log('me',this.me);

  }

  ngOnDestroy(): void {
    // 離開頁面時關閉本元件專屬的 websocket + 停掉 10 秒 ping 計時器。
    // WebSocketService 用 providers:[WebSocketService] 綁在本元件（非 root 單例，也只有本元件注入），close() 只關自己這條連線。
    try {
      this.webSocketService.close();
    } catch(e) {
      console.log('ws close error', e);
    }
  }

  
  init_list(){
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count };
    this.httpClient.post<any>("/online_list.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.data = res.data;
        this.pageobj.total_count = res.total_count
      }else{
        this.pageobj.total_count = 0
        this.data = [];
      }
            // console.log(res);
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });
  }

  callitem(item){

    // 檢查是否已存在
    let exists = this.user_search.some(user => user.id === item.id && user.name === item.name);
    
    if (!exists) {
        this.user_search.push(item);
    }
    
  }

  chat_list(){
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count,type:this.filter_type ,search_target:this.search_target};
    this.httpClient.post<any>("/chat_list.php",body).subscribe(res => {
      this.loading = false;
      console.log(res);
      if(res.status){
        this.data = res.data;
        this.pageobj.total_count = res.total_count
      }else{
        this.pageobj.total_count = 0
        this.data = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });
  }
  group_msg_list(){
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count,type:this.msg_now ,search_target:this.search_target};
    this.httpClient.post<any>("/get_group_msg_list.php",body).subscribe(res => {
      this.loading = false;
      console.log('res',res);
      if(res.status){
        this.tag_list_type = res.groupTaglist.top;
        this.groupTaglist = res.groupTaglist.bottom;
        this.valuetag = res.groupTaglist.valuetag;
        this.data = res.data;
        this.pageobj.total_count = res.total_count;
        // this.user_search = res.user_Names;
      }else{
        this.pageobj.total_count = 0
        this.data = [];
        this.user_search = [];
      }
      this.pageobjstr = JSON.parse(JSON.stringify(this.pageobj));
      this.groupTagArr = [];
      // loading 結束後才顯示 toast
      if(this.pending_toast){
        this.show_toast(this.pending_toast);
        this.pending_toast = '';
      }
    });
  }
  get_sheet_return_list(){
    this.loading = true;
    console.log(this.msg_now)
    const body = {page: this.pageobj.page,count:this.pageobj.count,status:this.msg_now ,search_target:this.search_target};
    this.httpClient.post<any>("/get_sheet_return_list.php",body).subscribe(res => {
      this.loading = false;
      console.log(res);
      if(res.status){
        this.data = res.data;
        this.pageobj.total_count = res.total_count
      }else{
        this.pageobj.total_count = 0
        this.data = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });
  }

  sheet_save(){
      this.loading = true;
      const body = {data:this.edit_data};
      this.httpClient.post<any>("/update_sheet.php",body).subscribe(res => {
        this.loading = false;
        console.log(res);
        this.get_sheet_return_list();
        this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
      });
    
  }

  // 沒指定用戶時，視為不加搜尋用戶條件（避免被當成「指定 0 人」過濾掉全部）
  build_edit_data_for_save(){
    const data = {...this.edit_data};
    if(!this.user_search || this.user_search.length == 0){
      data.user_mode = '0';
    }
    return data;
  }

  // 儲存前先預覽人數（不開 loading，由 do_save 才觸發 spinner）
  confirm_save(type:number){
    if(this.edit_data.msg.length==0){
      alert('訊息不可為空');
      return;
    }
    const body = {data:this.build_edit_data_for_save(),groupTagArr:this.groupTagArr,user_search:this.user_search};
    this.httpClient.post<any>("/count_group_msg_targets.php", body).subscribe({
      next: (res) => {
        if(res.status){
          this.confirm_modal = {show:true, count:res.total_count, save_type:type};
        }else{
          alert('查詢人數失敗：' + (res.message || ''));
        }
      },
      error: (err) => {
        alert('查詢人數失敗');
      }
    });
  }

  cancel_confirm(){
    this.confirm_modal.show = false;
  }

  do_save(){
    const type = this.confirm_modal.save_type;
    this.confirm_modal.show = false;
    // 編輯 modal 先關（修改流程）
    if(type == 0){
      try { $('.bd-example-modal-xl').modal('hide'); } catch(e){}
    }
    this.save(type);
  }

  collapse_group_setting(){
    try { $('#collapseOne').collapse('hide'); } catch(e){ console.log('collapse error', e); }
    // 保險：直接拔掉 .show class
    const el = document.getElementById('collapseOne');
    if(el){
      el.classList.remove('show');
      el.style.height = '';
    }
    // 同步更新觸發按鈕的 aria 狀態
    const trigger = document.querySelector('[data-target="#collapseOne"]');
    if(trigger){
      trigger.setAttribute('aria-expanded','false');
      trigger.classList.add('collapsed');
    }
  }

  show_toast(msg:string){
    this.toast = {show:true, msg:msg};
    setTimeout(() => { this.toast.show = false; }, 2200);
  }

  save(type){
    if(this.edit_data.msg.length==0){
      alert('訊息不可為空');
    }else{
        this.loading = true;

        // 20秒後設置 loading 為 false
        setTimeout(() => {
            this.loading = false;
        }, 20000);

        const body = {type:type,data:this.build_edit_data_for_save(),groupTagArr:this.groupTagArr,user_search:this.user_search};
        this.httpClient.post<any>("/update_group_msg.php", body).subscribe({
            next: (res) => {
              console.log(res);
              if(res && res.status){
                // 排程 toast，等 group_msg_list 完成後 loading 結束才顯示
                this.pending_toast = type == 1 ? '已新增' : '已儲存';
                if(type == 1){
                  this.collapse_group_setting();
                  this.get_default_edit_data();
                }
              }else{
                this.loading = false;
                alert((type == 1 ? '新增' : '儲存') + '失敗：' + (res && res.message ? res.message : ''));
                return;
              }
              this.group_msg_list();
              this.pageobjstr = JSON.parse(JSON.stringify(this.pageobj));
            },
            error: (err) => {
              this.loading = false;  // 请求失败时也设置 loading 为 false
              console.error('请求失败:', err);
              alert('請求失敗');
            },

        });
    }

  }

  choose():void{
    this.logs = [];
    this.nowpacket = 0;
    this.target.uid = '-1';

    if(this.now=='0'){
        this.init_list();
    }else if (this.now=='1'){
        this.chat_list();
    }else if(this.now=='4'){

        this.tcontent = [
            {title:'訊息',content:'msg',type:3,css:'max-width:220px;'},
            {title:'性別',content:'gender',type:3},
            {title:'身分',content:'identity',type:3},
            {title:'活躍狀態',content:'active_status',type:3},
            {title:'是否推播',content:'fcm_notice',type:3},
            {title:'發送狀態',content:'send_type',type:3},
            {title:'通知人數',content:'receive_num'},
            {title:'預約時間',content:'gsend_type_time',type:3},
            {title:'建立時間',content:'create_dt'},
            {title:'操作',content:'gg',type:3},
        ];
        
        this.group_msg_list();
    }else if(this.now=='5'){

        this.tcontent = [
            {title:'用戶',content:'name',type:2},
            {title:'狀態',content:'s_name'},
            {title:'回報點',content:'create_dt'},
            {title:'描述',content:'descript',type:3},
            {title:'操作',content:'gg',type:3},
        ];
        
        this.get_sheet_return_list();
    }

    this.get_default_edit_data();
  }

  select_user(item:any){
    
    if(typeof(item.uid)=='undefined'){
      this.target.uid = item.user_uid;
    }else{
      this.target.uid = item.uid;
    }
    
    this.loading = true;

    const read = this.webSocketService.get_orimsg('read_complete')
    read.content = '';
    read.to_userid = this.target.uid;
    this.webSocketService.sendMessage(read);


    const body = {packet:this.nowpacket,meuid:this.me.uid,uid: this.target.uid };
    // console.log(body);
    this.httpClient.post<any>("/get_chat_history.php",body).subscribe(res => {
      this.loading = false;
      this.now = '2';
      console.log(res);
      this.target.name = item.name;
      this.target.profile_pic = item.profile_pic;
      if(res.status){

        if(this.nowpacket!=0){
          res.data.reverse();
        }

        this.freshload = true;
        res.data.forEach((v)=>{
            // console.log('push')
          let me = v.user_uid == this.me.uid ? true:false
          let img = v.user_uid == this.me.uid ? this.me.profile_pic:this.target.profile_pic
          let uid = v.user_uid == this.me.uid ? this.me.uid:this.target.uid
          let name = v.user_uid == this.me.uid ? this.me.name:this.target.name
          let media = v.type != 1 ? JSON.parse(v.media):'';
          if(v.user_uid != 'system'){
            let tmp = {
                type:v.type,
                time:v.time,
                name:name,
                user_img: img,
                meid:uid,
                action:'say',
                content:v.content,
                media: media,
                list:[],
                unsafe:0,
                me:me
              }
              if(this.nowpacket==0){
                this.logs.push(tmp);
              }else{
                this.logs.unshift(tmp);
              }
          }
          
          
        })
      }

    });

    if(this.nowpacket == 0){
      window.setTimeout(()=>{
        document.getElementById("chat_box").addEventListener('scroll', this.scroll.bind(this), true);
        const div = document.getElementById('chat_box');
        div.scrollTop = div.scrollHeight;
      },1200)  
    }
    

  }


  get_default_edit_data(){

    this.groupTagArr = [];
    this.user_search = [];

    this.edit_data = {
      identity:[1,2,3],
      gender:[1,2],
      active_status:'0',
      send_type:'0',
      fcm_notice:'0',
      user_mode:'1',
      msg:'',
      target_time:'',
    };
  }


  ck_checkbox(now:number,type){

    const target = type == 1?'identity':'gender';

    const index = this.edit_data[target].findIndex((v)=>{
      return now == v;
    })
    if(index==-1){
      this.edit_data[target].push(now);
    }else{
      if( this.edit_data[target].length==1){
        alert('至少要有一個身分');
      }else{
        this.edit_data[target].splice(index,1)
      }
     
    }
    console.log(now);
  }

  scroll(e){
    const now = document.getElementById("chat_box").scrollTop //當前
    const height = document.getElementById("chat_box").scrollHeight;//總高度
    if(now / height < 0.35 && this.freshload){
      this.freshload = false;
      this.loadmore();
      // console.log('有load')
    }
  }
  loadmore(){
    this.nowpacket++;
    this.select_user(this.target);
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.choose();
    }
  }

  send(){
    if(this.send_data.msg.trim().length>0){
      const send = this.webSocketService.get_orimsg('say')
      send.content = this.send_data.msg;
      send.user_id = this.me.uid;
      send.user_name = this.me.name;
      send.user_img = this.me.profile_pic;
      send.to_userid = this.target.uid;
      this.webSocketService.sendMessage(send);
      // console.log('init?',send);
      this.send_data.msg = '';  
    }
    
  }
  isArray(obj : any ){
    return Array.isArray(obj)
  }
}

